import styled from 'styled-components';
import DefaultCurrencyInput from 'react-currency-input-field';
import { inputCommonStyle } from '~components/dumbs/Input/styled';

export const CurrencyInput = styled(DefaultCurrencyInput)`
  ${inputCommonStyle}
`;
